import http from './http';

// 列表
export const fetchTakeCareList = (data) => {
  return http({
    url: '/advance/care/list',
    method: 'POST',
    data,
  });
};

// 修改
export const fetchUpdateTakeCare = (data) => {
  return http({
    url: '/advance/care/update',
    method: 'POST',
    data,
  });
};

// 详情
export const fetchTakeCareDetail = (data) => {
  return http({
    url: '/advance/care/detail',
    method: 'POST',
    data,
  });
};

// 关怀记录
export const fetchTakeCareHistory = (params) => {
  return http({
    url: '/advance/care/queryAdvanceCareRecord',
    params,
  });
};

// 预到关怀统计
export const fetchTakeCareStatistics = (data) => {
  return http({
    url: '/advance/care/statistics',
    method: 'POST',
    data,
  });
};
